import WithErrorBoundary from './WithErrorBoundary';

export default WithErrorBoundary;
